<template>
    <div>
        <!-- Bulk
    {{module_list}}-->
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <strong>Parent Bulk Role Assignment</strong>
            </v-toolbar>
            Click 'Push' to add roles to parents => <v-btn :loading="parent_load" class="button"
                :disabled="isallowed == false ? true : false" @click="selectmodules_parentrole">Push</v-btn> <br />
            <span style="opacity: 0.5;">Note: This may take time, depending upon no of parents in the system</span>
            <v-row v-if="parent_roles != ''" dense justify="center">
                <span v-for="roles in parent_roles" :key="roles.roles_id">
                    <v-checkbox multiple class="mr-5" dense v-model="add_parent_role" :label="roles.roles"
                        :value="roles.roles_id"></v-checkbox>
                </span>
                <v-btn v-if="parent_roles" :loading="parent_role_load" class="button"
                    @click="addParentBulkRole(add_parent_role)">Add Role</v-btn>
            </v-row>
        </v-card>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <strong>Learner Bulk Role Assignment</strong>
            </v-toolbar>
            Click 'Push' to add roles to learner => <v-btn :loading="learner_load" class="button"
                :disabled="isallowed == false ? true : false" @click="selectmodules">Push</v-btn><br />
            <span style="opacity: 0.5;">Note: This may take time, depending upon no of learner in the system</span>
            <br />
            <v-row v-if="learner_roles != ''" dense justify="center">
                <span v-for="roles in learner_roles" :key="roles.roles_id">
                    <v-checkbox multiple class="mr-5" dense v-model="add_learner_role" :label="roles.roles"
                        :value="roles.roles_id"></v-checkbox>
                </span>
                <v-btn v-if="learner_roles" :loading="learner_role_load" class="button"
                    @click="addLearnerBulkRole(add_learner_role)">Add Role</v-btn>
            </v-row>
        </v-card>
        <v-card :loading="mount_load" class="box">
            <v-card-title class="brand onBrand--text">
                <strong> Employee Bulk Role Assignment</strong>
            </v-card-title>
            <v-card-text>
                <center>
                    <h3>Choose anyone category</h3>
                    <span style="opacity: 0.5;">(Designation/Employee type/Class teacher/Employee)</span>
                </center>
                <v-row dense justify="center">
                    <v-col cols="12" sm="2" md="2">
                        <v-autocomplete outlined dense rounded :items="designation_list" v-model="designation"
                            item-text="name" return-object label="Select Designation"
                            @change="emp_type=null;class_teacher=false;employee=null"
                            ref="ref_category"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <br />
                        <center><b>OR</b></center>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-autocomplete dense outlined rounded :items="emp_type_list" v-model="emp_type"
                            item-text="name" return-object label="Select Employee Type"
                            @change="designation=null;class_teacher=false;employee=null"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="1" md="1">
                        <br />
                        <center><b>OR</b></center>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-checkbox @change="designation=null;emp_type=null;employee=null" dense v-model="class_teacher"
                            label="Class Teacher"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="1" md="1">
                        <br />
                        <center><b>OR</b></center>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-autocomplete outlined rounded multiple dense :items="employee_list" v-model="employee"
                            item-text="name" item-value="id" label="Select Employee"
                            @change="emp_type=null;class_teacher=false;designation=null"
                            ref="ref_category"></v-autocomplete>
                    </v-col>
                </v-row>
                <br />
                <v-card class="box">
                    <v-card-title class="brandMixWhite white--text">
                        <center>
                            <h3>Tick applicable roles from respective modules</h3>
                        </center>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col md="3">
                                <h3>MODULES</h3>
                            </v-col>
                            <v-col md="9">
                                <h3>ROLES</h3>
                            </v-col>
                        </v-row>
                        <v-row v-for="(module,index) in module_list" :key="module.id"
                            :class="(index % 2==0?'even':'odd')">
                            <v-col md="3">
                                <b>{{module.module_name}}</b>
                            </v-col>
                            <v-col md="9">
                                <v-row>
                                    <v-col md="2" v-for="role in module.mod_role_list" :key="role.id">
                                        <v-checkbox dense v-model="add_role" :label="role.role_name"
                                            :value="role.role_id"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <center>
                        <v-btn class="button" :loading="emp_role_load" @click="addEmpBulkRoles">Add Roles</v-btn>
                    </center>
                    <br />
                </v-card>
            </v-card-text>
        </v-card>

        <div v-if="added_emp_role!=null">
            <v-card class="box">
                <v-card-title class="toolbar">
                    <h3>Roles added to following Employees</h3>
                </v-card-title>
                <v-card-text>
                    <ol>
                        <li v-for="(name,index) in added_emp_role" :key="index">{{name}}</li>
                    </ol>
                </v-card-text>
            </v-card>
        </div>
        <div v-if="added_parent_role!=null">
            <v-card>
                <v-card-text>
                    <h3>Roles {{parent_roles}} added to following Parents</h3>

                    <ol>
                        <li v-for="(name,index) in added_parent_role" :key="index">{{name}}</li>
                    </ol>
                </v-card-text>
            </v-card>
        </div>
        <div v-if="added_learner_role!=null">
            <v-dialog v-model="dialog" max-width="900px">
                <v-card>
                    <v-toolbar flat dense class="toolbar">
                        <strong>Roles {{learner_roles}} added to following Learner</strong>
                    </v-toolbar>
                    <v-card class="box">
                        <v-toolbar flat dense>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-toolbar>
                        <v-data-table :headers="headers" :items="added_learner_role" dense class="elevation-1 mytable"
                            :search="search"> </v-data-table>
                    </v-card>
                    <center><v-btn class="button" @click="dialog = false">close</v-btn></center>
                </v-card>
            </v-dialog>
        </div>

        <!-- {{add_role}}
        {{emp_type}}
    {{designation}}-->
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                isallowed:false,
                module_list: null,
                designation_list: null,
                designation: null,
                // extraBreadcrumbItems: [
                 

                // ],
                // breadcrumbClass: "breadcrumb-style1",
                emp_type_list: null,
                emp_type: null,
                add_role: [],
                class_teacher: false,
                mount_load: false,
                emp_role_load: false,
                parent_role_load: false,
                learner_role_load: false,
                //
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                added_emp_role: null,
                added_learner_role: null,
                added_parent_role: null,
                added_learner_role: null,
                parent_roles: "",
                learner_roles: [],
                dialog: false,
                add_learner_role: [],
                add_parent_role: [],
                learner_load: false,
                parent_load: false,
                employee:null,
                employee_list:[],
                search: "",
                headers: [
                    { text: "Sr. No.", value: "srno" },
                    { text: "Learner", value: "name" },
                ],
            };
        },
        methods: {
            selectmodules() {
                this.added_learner_role = null;
                this.added_learner_role = null;
                this.learner_load = true;
                axios
                    .post("/roleManagement/selectmodules")
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.learner_roles = res.data.learner_roles;
                        } else {
                            alert(res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong...!!!");
                    })
                    .finally(() => {
                        //stop loader
                        this.learner_load = false;
                    });
            },
            selectmodules_parentrole() {
                this.added_parent_role = null;
                this.added_parent_role = null;
                this.parent_load = true;
                axios
                    .post("/roleManagement/selectmodules_parentrole")
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.parent_roles = res.data.parent_roles;
                        } else {
                            alert(res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong...!!!");
                    })
                    .finally(() => {
                        //stop loader
                        this.parent_load = false;
                    });
            },
            addParentBulkRole(role) {
                this.added_emp_role = null;
                this.added_parent_role = null;
                this.parent_role_load = true;
                const formdata = {
                    roles: role,
                };
                axios
                    .post("/roleManagement/addParentBulkRole", formdata)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.added_parent_role = res.data.added_parent_role;
                            this.parent_roles = res.data.parent_roles;
                            if (this.added_parent_role.length == 0) alert("No parent found");
                            else {
                                alert("Roles added succesfully. Please scroll down for parent list");
                            }
                        } else {
                            alert(res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong...!!!");
                    })
                    .finally(() => {
                        //stop loader
                        this.parent_role_load = false;
                        this.parent_roles = null;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            addLearnerBulkRole(role) {
                this.added_learner_role = null;
                this.added_learner_role = null;
                this.learner_role_load = true;
                const formdata = {
                    roles: role,
                };
                axios
                    .post("/roleManagement/addLearnerBulkRole", formdata)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.added_learner_role = res.data.added_learner_role;
                            this.learner_roles = res.data.learner_roles;
                            if (this.added_learner_role.length == 0) alert("No learner found");
                            else {
                                this.dialog = true;
                                this.showSnackbar("#4caf50", "Learner roles added succesfully...."); // show snackbar on success
                                //alert("Roles added succesfully. Please scroll down for learner list");
                            }
                        } else {
                            alert(res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong...!!!");
                    })
                    .finally(() => {
                        //stop loader
                        this.learner_role_load = false;
                        this.learner_roles = null;
                    });
            },

            addEmpBulkRoles() {
                if (this.designation == null && this.emp_type == null && this.class_teacher == false && this.employee == null) {
                    alert("Please select category!!!");
                    //ref_category
                    this.$refs.ref_category.focus();
                    return;
                }
                if (this.add_role.length == 0) {
                    alert("Please tick atleast one role!!!");
                    return;
                }
                const formData = {
                    designation: this.designation,
                    emp_type: this.emp_type,
                    class_teacher: this.class_teacher,
                    add_roles: this.add_role,
                    employee:this.employee
                };
                this.emp_role_load = true;
                this.added_emp_role = null;
                this.added_parent_role = null;
                axios
                    .post("/roleManagement/addEmpBulkRoles", formData)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.added_emp_role = res.data.added_emp_role;
                            if (this.added_emp_role.length == 0) alert("No employee found");
                            else {
                                alert("Roles added succesfully. Please scroll down for employees list");
                            }
                        } else {
                            alert(res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong...!!!");
                    })
                    .finally(() => {
                        //stop loader
                        this.emp_role_load = false;
                    });
            },
        },
        mounted() {
            //start loader
            this.mount_load = true;
            axios
                .post("/roleManagement/bulkRole")
                .then((res) => {
                    if (res.data.flag == "YES") {
                    this.module_list = res.data.module_list;
                    this.designation_list = res.data.designation_list;
                    this.emp_type_list = res.data.emp_type_list;
                    this.employee_list = res.data.employee_list
                    this.mount_load = false;
                     this.isallowed=res.data.isallowed
                    }
                    else if (res.data.flag == "No"){
                        this.showSnackbar("red", res.data.snackbar);
                        this.isallowed=res.data.isallowed
                        this.overlay = false;
                 }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    //stop loader
                });
        },
    };
</script>
<style scoped>
    .even {
        background-color: whitesmoke;
    }
    .odd {
        background-color: white;
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
